import { union } from 'io-ts/Decoder';

import { Id as JobId } from '../job/Id';
import { Id as TransactionId } from '../transaction/Id';

export const ParentId = union(JobId, TransactionId);
